import { bannerInlineStylesScale } from "..";

function bannerInlineStyleBody(_ref) {
  var _ref$layout = _ref.layout,
      type = _ref$layout.type,
      bannerMaxWidth = _ref$layout.bannerMaxWidth,
      individualLayout = _ref.individualLayout,
      antiAdBlocker = _ref.customCss.antiAdBlocker,
      mobile = _ref.mobile,
      individualPrivacyOpen = _ref.individualPrivacyOpen,
      pageRequestUuid4 = _ref.pageRequestUuid4;
  var style = {
    transition: "width 500ms, max-width 500ms",
    maxWidth: bannerInlineStylesScale(mobile, pageRequestUuid4, type, "banner") === "banner" ? +(individualPrivacyOpen && !individualLayout.inheritBannerMaxWidth ? individualLayout.bannerMaxWidth : bannerMaxWidth) : undefined,
    margin: "auto"
  };
  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-body",
    style: style
  };
}

export { bannerInlineStyleBody };